import {Component, Inject} from '@angular/core';
import {CommonModule} from "@angular/common";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {
  CdkDrag,
  CdkDragDrop,
  CdkDropList,
  moveItemInArray
} from '@angular/cdk/drag-drop';
import { SwitchComponent } from '@charlesschwab/as-ui-core';
import {IrbCommonModule} from "@irb-common/irb-common.module";
import {CardModule} from 'primeng/card';


@Component({
  selector: 'irb-module-customizer',
  templateUrl: './module-customizer.component.html',
  styleUrl: './module-customizer.component.scss',
  standalone: true,
  imports: [CommonModule, CdkDropList, CdkDrag, CardModule, IrbCommonModule, SwitchComponent]
})
export class ModuleCustomizerComponent {
  modulesToBuild: Array<any> = [];
  isUiTest: boolean = false;
  disableSwitch: boolean = false;

  constructor(public dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public mdd: any) {
    if (this.mdd) {
      this.modulesToBuild = this.mdd.modulesToBuild || [];
      this.setToggleDisableIfSingle();
    }
    // setTimeout(() => {
    //   let e = document.querySelector('.cdk-drag-preview');
    //   let e1 = document.querySelector('.cdk-drag-dragging');
    //
    //   if (e) {
    //     console.log(e.outerHTML);
    //     console.log(e1.outerHTML);
    //   }
    // },10000)
  }

  close() {
    this.dialogRef.close();
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.modulesToBuild, event.previousIndex, event.currentIndex);
  }

  toggleEnableModule(module: any) {
    const fromIndex = this.modulesToBuild.findIndex((m: any) => m.id === module.id);
    let toIndex = this.modulesToBuild.findIndex((m: any) => !m.enabled);

    module.enabled = !module.enabled;

    if (!module.enabled) {
        toIndex = this.modulesToBuild.length - 1;
    }
    if (fromIndex !== toIndex && toIndex !== -1)
      moveItemInArray(this.modulesToBuild, fromIndex, toIndex);

    this.setToggleDisableIfSingle();
  }

  save() {
    const modulesToSave = JSON.parse(JSON.stringify(this.modulesToBuild));
    this.dialogRef.close(modulesToSave);
  }

  toggleModuleWidth(module: any, newSingleWidth: boolean) {
    module.singleWidth = newSingleWidth;
  }

  setToggleDisableIfSingle() {
    const count = this.modulesToBuild.filter(item => item.enabled === true).length;
    this.disableSwitch = count < 2;
  }

}
